import { z } from 'zod'
import { ItemVariableSchema } from '../schemas'
import { http } from './http'
import { auth } from './auth'
import { parseWithZod } from '../utils/parse-with-zod'

const SetItemVariableValueResponseSchema = z.object({
  item_variable: ItemVariableSchema,
})

export const itemVariables = {
  updateItemVariable: async (variableId: number, value: string | null, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/item_variables/${variableId}/set_value`,
      {
        value,
      },
      dealId,
    )
    const parsedResult = parseWithZod(SetItemVariableValueResponseSchema, result)
    return parsedResult
  },

  unlinkItemVariable: async (variableId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/item_variables/${variableId}/unlink`,
      {},
      dealId,
    )
    const parsedResult = parseWithZod(SetItemVariableValueResponseSchema, result)
    return parsedResult
  },

  linkItemVariable: async (variableId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/item_variables/${variableId}/link`,
      {},
      dealId,
    )
    const parsedResult = parseWithZod(SetItemVariableValueResponseSchema, result)
    return parsedResult
  },
}
